import React from 'react';

export default function BulletList({ items, className = '' }) {
  const safe = Array.isArray(items) ? items.filter(Boolean) : [];
  if (safe.length === 0) return null;

  return (
    <ul className={`list-disc pl-5 space-y-1 ${className}`}>
      {safe.map((it, idx) => (
        <li key={idx} className="text-sm text-gray-800 leading-snug">
          {it}
        </li>
      ))}
    </ul>
  );
}


